import React, { useContext, useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart,
  ArcElement,
  Tooltip,
  Legend,
  Title,
  TooltipItem,
  ChartTypeRegistry,
} from 'chart.js';
import '../../style.scss';

Chart.register(ArcElement, Tooltip, Legend, Title);
export interface IProps {
  expectedAnnualCost: any;
}

export const DoughnutChart = ({ expectedAnnualCost }: IProps) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' && window.innerWidth < 768,
  );
  const [isMobileX, setIsMobileX] = useState(
    typeof window !== 'undefined' && window.innerWidth < 370,
  );

  const plugin = {
    id: 'legendDistance',
    beforeInit(chart: any, args: any, opts: any) {
      // Get reference to the original fit function
      const originalFit = chart.legend.fit;
      // Override the fit function
      chart.legend.fit = function fit() {
        // Call original function and bind scope in order to use `this` correctly inside it
        originalFit.bind(chart.legend)();
        // Specify what you want to change, whether the height or width
        this.width += opts.padding || 0;
      };
    },
  };

  const options = {
    maintainAspectRatio: true,
    cutout: '50%',
    responsive: true,
    legend: {
      display: isMobile ? false : true,
      rtl: true,
      position: 'bottom',
      align: 'left',
    },
    layout: {
      padding: {
        bottom: 150,
      },
    },
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        display: isMobileX ? false : true,
        position: 'right' as const,
        labels: {
          boxWidth: 8,
          boxHeight: 8,
          usePointStyle: true,
          borderRadius: 100,
          font: {
            size: isMobile ? 10 : 14,
            family: "'IBM Plex Sans Arabic', sans-serif",
            lineHeight: '150%',
            color: '#40BFFF',
          },
        },
      },
      legendDistance: {
        padding: isMobile ? 0 : 50, // dictates the space
      },
      title: {
        display: true,
        text: '',
        position: 'bottom' as const,
        align: 'center' as const,
        font: {
          size: 16,
          family: "'IBM Plex Sans Arabic', sans-serif",
          lineHeight: '150%',
          color: '#40BFFF',
        },
      },
      tooltip: {
        callbacks: {
          label: function (context: TooltipItem<keyof ChartTypeRegistry>) {
            let label = context.dataset.label || '';

            if (label) {
              label += ': ';
            }
            if (context.formattedValue !== null) {
              label += '$' + context.formattedValue;
            }
            return label;
          },
        },
        TitleFont: {
          family: "'IBM Plex Sans Arabic', sans-serif",
        },
        bodyFont: {
          family: "'IBM Plex Sans Arabic', sans-serif",
        },
      },
    },
    elements: {
      arc: {
        borderWidth: 0,
      },
    },
  };

  const data = {
    labels: [
      `Support Tickets`,
      `Planning / Evaluations`,
      `Montioring Environment`,
      `Application Optimization`,
      `Security/Compliance`,
      `User Access`,
      `Data Protection`,
      `New Installs`,
    ],
    datasets: [
      {
        data: [
          expectedAnnualCost.costsSuppTickets,
          expectedAnnualCost.costsPlanningEval,
          expectedAnnualCost.costsMonitoring,
          expectedAnnualCost.costsAppOptimization,
          expectedAnnualCost.costsSecurityCompliance,
          expectedAnnualCost.costsUserAccess,
          expectedAnnualCost.costsDataProtection,
          expectedAnnualCost.costsNewInstalls,
        ],
        // data: [props.savings_risk, props.benefit_empProductivity, props.savings_risk, props.savings_risk, props.savings_risk, props.savings_risk, props.savings_risk],
        backgroundColor: [
          '#0F62FE',
          '#0072C3',
          '#007D79',
          '#198038',
          '#6929C4',
          '#D02670',
          '#3DDBD9',
        ],
        borderColor: 'white',
        borderWidth: 1,
        radius: '100%',
      },
    ],
  };

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 769);
      setIsMobileX(window.innerWidth < 370);
    }

    if (typeof window !== 'undefined') {
      handleResize();
    }

    window.addEventListener('resize', handleResize);
    return () => {
      // remove event listener when the component is unmounted to not cause any memory leaks
      // otherwise the event listener will continue to be active
      window.removeEventListener('resize', handleResize);
    };
    // add `isMobile` state variable as a dependency so that
    // it is called every time the window is resized
  }, [isMobile]);

  return (
    <div className="doGraph-box">
      <div className="doGraph">
        <Doughnut plugins={[plugin]} data={data} options={options} />
      </div>
    </div>
  );
};
